import { useEffect } from 'react';
// import useJsBridge from '@/models/jsBridge';
import { useModel } from 'umi';
import { queryOfURL } from '@/utils/url';
import { isInZhuzher } from '@/utils/env';
import {
  getCacheProjectInfo,
  updateCacheProjectInfo,
} from '@/utils/cacheProjectCode';

// 缓存urlprojectCode相关信息，方便开发
export const URL_PROJECT_CODE_LOCAL_STORAGE_KEY =
  'URL_PROJECT_CODE_LOCAL_STORAGE_KEY';

/**
 * 分别从url 和jsbridge获取project
 * 如果url有projectCode 优先返回url的
 */
export default function useProject() {
  const [jsBridgeProjectCode, jsBridgeProjectName] = useProjectByJsBridge();
  // 优先住这儿里面的Project信息，由于使用了hooks，所以这里更新放在useEffect，当其它地方更新，刷新一下本地缓存的project信息，免得出现缓存里面一直是旧的project信息
  useEffect(() => {
    if (jsBridgeProjectCode) {
      // 缓存，下次直接从内存取
      updateCacheProjectInfo(jsBridgeProjectCode, jsBridgeProjectName);
      // 缓存住这儿数据，以便通过webview打开时带到其他页面
      localStorage.setItem(
        URL_PROJECT_CODE_LOCAL_STORAGE_KEY,
        JSON.stringify([jsBridgeProjectCode, jsBridgeProjectName]),
      );
    }
  }, [jsBridgeProjectCode, jsBridgeProjectName]);

  const { projectCode: urlProjectCode, projectName } = queryOfURL(
    location.search,
  );
  if (urlProjectCode && urlProjectCode !== 'undefined') {
    const urlProjectName =
      urlProjectCode === '44030999' ? '梅林路63号' : projectName;
    // 临时缓存，以便带到其他页面
    localStorage.setItem(
      URL_PROJECT_CODE_LOCAL_STORAGE_KEY,
      JSON.stringify([urlProjectCode || '', urlProjectName || '']),
    );
    updateCacheProjectInfo(urlProjectCode, urlProjectName);
  }
  // URL
  if (getCacheProjectInfo()[0]) {
    console.log('取缓存projectCode信息 222', getCacheProjectInfo());
    return getCacheProjectInfo();
  }

  // 使用缓存
  let localStorageProject: Array<string> | string =
    localStorage.getItem(URL_PROJECT_CODE_LOCAL_STORAGE_KEY) ||
    `["44030999", "梅林路63号"]`;
  try {
    localStorageProject = JSON.parse(localStorageProject);
  } catch {
    localStorageProject = ['44030999', '梅林路63号'];
  }
  if (!isInZhuzher && (localStorageProject as Array<string>)[0]) {
    return localStorageProject;
  }
  return [
    jsBridgeProjectCode,
    jsBridgeProjectCode === '44030999' ? '梅林路63号' : jsBridgeProjectName,
  ];
}

/**
 * 从jsBridge获取project信息
 */
export function useProjectByJsBridge() {
  const { jsBridgeState, getProject } = useModel('jsBridge');

  useEffect(() => {
    getProject();
  }, [getProject]);

  const { projectCode, projectName } = jsBridgeState;
  return [projectCode, projectName];
}
